import TableToolBar from './table-tool-bar'

export default TableToolBar